import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import LinkIcon from './images/link.vue.svg';
import type { IPostContentDataLink } from '@/types/community';

type WarRoomPostContentLinkProps = {
  content: IPostContentDataLink;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomPostContentLink',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as {
  content: IPostContentDataLink;
};



const IMAGE_SIZE = 64;

const isLinkOnly = computed(() => !props.content.link_title && !props.content.link_description);
const iconStyles = computed(() => ({
  width: isLinkOnly.value ? IMAGE_SIZE / 2 : IMAGE_SIZE,
  height: isLinkOnly.value ? IMAGE_SIZE / 2 : IMAGE_SIZE,
}));
const urlStyles = computed(() => ({
  'war-room-post-content-link__url': true,
  'war-room-post-content-link__url--standalone': isLinkOnly.value,
}));

return { __sfc: true,props, IMAGE_SIZE, isLinkOnly, iconStyles, urlStyles, LinkIcon }
}

})